<app-admin-menu></app-admin-menu>

<h1 class="mat-headline-3">Nytt schema</h1>

<div class="container">
    <div class="row">
        <div class="col">
            <button mat-button class="back" routerLink="/admin/schedules">
                <mat-icon>chevron_left</mat-icon>
                Tillbaka
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <app-schedule-form></app-schedule-form>
        </div>
    </div>
</div>

<app-messages #messagesPartial [employeeId]="employeeId"></app-messages>

<app-admin-footer></app-admin-footer>
